import { __assign } from "tslib";
/* I51 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
import { useFlag } from '../../redux/flags/hooks/useFlag';
var Bell = function (props) {
    var isNewHomepage = useFlag('cdc_new_homepage');
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", null, isNewHomepage ? (React.createElement("path", { d: "M11.8286 15.999A2.995 2.995 0 0112 17.0008c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-.3513.0604-.6885.1714-1.0018h5.6572zM9 0c3.3323 0 7 2.5 7 7v4l1 2h1v2H0v-2h1l1-2V7c0-4.5 3.6677-7 7-7z" })) : (React.createElement("path", { d: "M19 15.388C19 9.728 17.7 4 12 4S5 9.727 5 15.388h14zM11.945 20c1.56 0 3.308-3 3.025-3H9s1.385 3 2.945 3z" }))))));
};
Bell.displayName = 'Bell';
export default Bell;
//# sourceMappingURL=Bell.js.map